import React, { useMemo } from 'react';
import { Card, Col, Row, Typography, List, Tag } from 'antd';
import { ClockCircleOutlined, GlobalOutlined, CodeOutlined } from '@ant-design/icons';
import { mockWebsites, mockSnippets, mockSystemActivity } from '../../Super Admin/mockData';

const { Title, Text } = Typography;

const ViewerDashboard = () => {
  const websiteCount = mockWebsites.length;
  const activeSnippets = useMemo(() => mockSnippets.filter(s => s.status === 'active').length, []);
  const lastActivity = mockSystemActivity[0]?.time ? new Date(mockSystemActivity[0].time).toLocaleString() : '-';

  const cards = [
    { title: 'Websites (View Only)', value: websiteCount, icon: <GlobalOutlined />, color: '#2563eb' },
    { title: 'Active Snippets', value: activeSnippets, icon: <CodeOutlined />, color: '#16a34a' },
    { title: 'Last Activity', value: lastActivity, icon: <ClockCircleOutlined />, color: '#f59e0b' },
  ];

  return (
    <div>
      <Title level={2} style={{ marginBottom: 16 }}>Viewer Dashboard</Title>
      <Row gutter={[16, 16]}>
        {cards.map((c) => (
          <Col key={c.title} xs={24} sm={12} md={8}>
            <Card
              hoverable
              style={{ borderRadius: 14 }}
              bodyStyle={{ display: 'flex', alignItems: 'center', gap: 12 }}
            >
              <div style={{
                width: 40, height: 40, borderRadius: 10,
                background: c.color + '22', color: c.color,
                display: 'grid', placeItems: 'center', fontSize: 18
              }}>
                {c.icon}
              </div>
              <div>
                <Text type="secondary">{c.title}</Text>
                <div style={{ fontSize: 20, fontWeight: 700 }}>{c.value}</div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>

      <div style={{ marginTop: 18 }}>
        <Title level={4} style={{ marginTop: 8 }}>Recent System Activity</Title>
        <Card style={{ borderRadius: 14 }}>
          <List
            itemLayout="horizontal"
            dataSource={mockSystemActivity}
            renderItem={(a) => (
              <List.Item>
                <List.Item.Meta
                  title={<span>{new Date(a.time).toLocaleString()}</span>}
                  description={a.text}
                />
                <Tag color="blue">info</Tag>
              </List.Item>
            )}
          />
        </Card>
      </div>
    </div>
  );
};

export default ViewerDashboard;
